import React from 'react'

const PricingTableHeader = ({checkActiveTab, tabId, targetTab, name, type, packages}) => {
  return (
    packages && packages.length > 0 &&
    <li className="nav-item" role="presentation">
      <span
        className={`tab-item ${
          checkActiveTab(type) ? "active" : ""
        }`}
        id={tabId}
        href={`#${targetTab}`}
        role="tab"
        data-toggle="tab"
        aria-controls="subscription-props-month"
        aria-selected="false"
      >
        {name}
      </span>
    </li>
  )
}

export default PricingTableHeader